(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ActivityTypeInfo', ActivityTypeInfo);

    ActivityTypeInfo.$inject = ['$resource'];

    function ActivityTypeInfo($resource) {
        var resourceUrl = 'api/activity-type-infos/:id';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
